import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { routerEventsListenerInitiator } from "base/shared/tracking-headers";
import { isBrowser } from "base/shared/Utils";

import GeoSuggest from "./geo-suggest";

const GeoSuggestRoute = ({ router, ...props }) => {
  const routerEventsListener = routerEventsListenerInitiator(router);

  return <GeoSuggest routerEventsListener={routerEventsListener} {...props} />;
};

// polyfill for server
if (!isBrowser()) {
  global.Element = function () {};
}

GeoSuggestRoute.propTypes = {
  router: PropTypes.shape({
    listen: PropTypes.func.isRequired,
    replace: PropTypes.func.isRequired,
    getCurrentLocation: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    params: PropTypes.shape({
      text: PropTypes.string,
    }),
  }).isRequired,
};

export default withRouter(GeoSuggestRoute);
